import { DobPipe } from '../../../pipes/dob.pipe';
import { MedBadgesComponent } from '../../../med-badges/med-badges.component';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { BasketDetail, MedicationDetail, isMedPicked } from '../../models/batchpick-state';

export interface LastScan {
  basket: BasketDetail;
  med: MedicationDetail;
}

@Component({
  selector: 'app-current-scan-panel',
  standalone: true,
  imports: [DobPipe, CommonModule, DatePipe, MedBadgesComponent],
  templateUrl: './current-scan-panel.component.html',
  styleUrl: './current-scan-panel.component.css',
})
export class CurrentScanPanelComponent {
  @Input() lastScan: LastScan | null = null;
  @Output() reset = new EventEmitter<void>();

  isPicked(m: MedicationDetail): boolean { return isMedPicked(m); }

  trackByMed = (_: number, m: MedicationDetail) => m.medicationId;
}
